import { useQuery } from "@tanstack/react-query";


export function GetContratos() {
   const url = process.env.REACT_APP_URL_DIR + "contrato/list";
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Contratos"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json())
      // staleTime: 30000, // actualiza la pagina cada 30 segundos solo si salis y volves a entrar o se agrega info
      /*
    actualiza el query cada 4 segundos no importa que 
    refetchInterval: 4000 
    */
   });
   return data;
}
